<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card class="pa-4 text-center">

          <v-select
            v-model="selected"
            :items="eventos"
            item-text="value" item-value="id"
            @change="filtrarEvento"
            label="Selecciona una opción"
            outlined
            dense
          ></v-select>

          <div class="mb-4">
  <v-chip @click="filtrar(1)" color="green" class="ma-2">
    Confirmados: {{ totalConfirmados }}
  </v-chip>

  <v-chip @click="filtrar(0)" color="red" class="ma-2">
    Rechazaron: {{ totalRechazados }}
  </v-chip>

  <v-chip @click="filtrar(null)" color="blue" class="ma-2">
    Faltan por confirmar: {{ totalFaltan }}
  </v-chip>

  <v-chip @click="filtrar(true)" color="blue" class="ma-2">
    Total: {{ total }}
  </v-chip>
</div>


          <v-data-table
  :headers="headers"
  :items="confirmacionesFiltred"
  class="elevation-1"
>
  <template v-slot:item.confirmacion="{ item }">
    <span v-if="item.confirmacion === 1">✔</span>
              <span v-else-if="item.confirmacion === 0">✖</span>
              <span v-else>—</span>
  </template>
</v-data-table>




        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import invitacion from '@/assets/posada_invitacion.jpg'; // ajusta la ruta de tu invitación
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      invitacion,
      respuesta: null, // null hasta que traigamos la respuesta del usuario
      id: null,

      eventos: [
        { id: 1, value: 'Monterrey' },
        { id: 2, value: 'CDMX' },
      ],
      selected:  { id: 1, value: 'Monterrey' },

      lista: [],
      listaFiltered: [],

      confirmaciones: [],
      confirmacionesFiltred: [],
      headers: [
      { text: "Confirmación", value: "confirmacion" },
      { text: "Nombre Completo", value: "nombre_completo" },
      { text: "Plantel", value: "plantel" }
    ]
    };
  },

  computed:{

    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    totalConfirmados() {
      return this.confirmaciones.filter(c => c.confirmacion === 1).length;
    },

    totalRechazados() {
      return this.confirmaciones.filter(c => c.confirmacion === 0).length;
    },

    totalFaltan() {
      return this.confirmaciones.filter(c => c.confirmacion === null || c.confirmacion === undefined).length;
    },

    total() {
      return this.confirmaciones.length;
    }

  },
  async created() {
      //console.log( this.getdatosUsuarioERPERP )
      await this.obtenerListaConfirmados()
    },
  methods: {
    obtenerListaConfirmados() {
      console.log('get confirmacion')
      this.$http
        .get(`evento-lista`)
        .then((response) => {

          //console.log( response.data )

          this.lista = response.data

          console.log( this.selected )


          this.listaFiltered = this.lista.filter(i => [1, 4].includes( Number( i.estado ) ) || i.id_plantel === 13 )
          // TODO plantel != 13 && estado === 2
          this.confirmaciones = this.listaFiltered
          this.confirmacionesFiltred = this.listaFiltered




        })
        .catch((error) => {
          console.error('Error al obtener respuesta:', error);
        });
    },
    enviarRespuesta() {
      this.$http
        .post('evento-confirmacion', {
          confirmacion: this.respuesta,
          idusuario: this.getdatosUsuarioERPERP.id_usuario,
          idevento: 1,
          id: this.id
        })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Respuesta guardada',
            text:
              this.respuesta === 1
                ? 'Has confirmado tu asistencia.'
                : 'Has rechazado el evento.',
            confirmButtonText: 'Aceptar',
          });
        })
        .catch((error) => {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: error,
            confirmButtonText: 'Aceptar',
          });
        });
    },

    filtrar(value){
      //console.log( this.confirmaciones)
      if(value === true) this.confirmacionesFiltred = this.confirmaciones
      else this.confirmacionesFiltred = this.confirmaciones.filter(c => c.confirmacion === value )
    },

    filtrarEvento(){

      //console.log( this.selected )
      this.listaFiltered = this.lista

      if( this.selected === 1 ) {
        //console.log('filtrar mty')
        this.listaFiltered = this.listaFiltered.filter(i => [1, 4].includes( Number( i.estado ) ) || i.id_plantel === 13 )
      }
      else {
        //console.log('filtrar cdmx')
        this.listaFiltered = this.listaFiltered.filter(i => [2].includes( Number( i.estado ) ) )
      }
      this.confirmaciones = this.listaFiltered
      this.confirmacionesFiltred = this.listaFiltered

    }

  },
};
</script>
